import { lazy } from 'react';

const BankAccountsManagement = lazy(() => import('@/pages/bank-accounts/BankAccountsManagement'));
const BankAccountDetailView = lazy(() => import('@/pages/bank-accounts/BankAccountDetailView'));

export const bankAccountRoutes = [
    {
        path: 'bank-accounts',
        element: <BankAccountsManagement />,
    },
    {
        path: 'bank-accounts/:id',
        element: <BankAccountDetailView />,
    },
];
